export default __webpack_public_path__ + "static/media/Type 10.bce7a8b2.jpg";